<script>

import http from '@/utils/http'

function createAccount (password) {
  return http.post('/api/users/signup', {'password': password})
}

function clearUserInfo() {
  return http.delete('/api/user_info')
}

function getKanbanBe(type) {
  let endPoint = '/api/kanban_board'
  if(type) // no type provided = get all cards with no type filter
    endPoint += '/'+type;
    return http.get(process.env.VUE_APP_KANBAN_API_URL + endPoint)
}

function editKanbanBe(card_number, params){
  return http.post('/api/kanban_be_card/'+card_number, params)
}

function cancelKanbanBe(card_number){
  return http.put('api/kanban_be_card/' + card_number + '/cancel')
}

function exportCsvKanbanStat(month){
  return http.post(process.env.VUE_APP_KANBAN_API_URL + '/api/stat_kanban_periode/' + month,
  {},
    {
        responseType: 'blob'
    }
  )
}

function graphKanbanLeadtime(periode){
  return http.get(process.env.VUE_APP_KANBAN_API_URL + '/api/graph_stats_kanban/' + periode)
}

function graphScatter(){
  return http.get(process.env.VUE_APP_KANBAN_API_URL + '/api/stat_time_finish_kanban' )
} 

function attributionKanbanUpdate(type, params) {
  return http.post(process.env.VUE_APP_KANBAN_API_URL + '/api/kanban_board/'+ type, params)
}

function editOfficeTeams(params) {
  return http.post(process.env.VUE_APP_KANBAN_API_URL + '/data/update/management_team', params)
}

function getOfficeTeams() {
  return http.get(process.env.VUE_APP_KANBAN_API_URL + '/data/management_team')
}

function statMeanLeadTimePeriod() {
  return http.get(process.env. VUE_APP_KANBAN_API_URL + '/api/stats_mean_leadTime')
}


export default {
  createAccount,
  clearUserInfo, 
  getKanbanBe,
  editKanbanBe,
  attributionKanbanUpdate,
  editOfficeTeams,
  getOfficeTeams,
  cancelKanbanBe,
  exportCsvKanbanStat,
  graphKanbanLeadtime,
  graphScatter,
  statMeanLeadTimePeriod,
}

</script>1


// WEBPACK FOOTER //
// server.vue?33ee9401